import './team.scss';
import img_1 from './assets/1.png';
import img_2 from './assets/2.png';
import img_3 from './assets/3.png';
import img_4 from './assets/4.png';

export default function Team() {

    window.scrollTo(0, 0)

    return (
        <div className="team">
            <div className='bg'></div>

            <div className='content'>
                <div className="row">
                    <div>
                        <h2>
                            Представляем вам нашу команду профессионалов
                        </h2>
                    </div>
                    <div>
                        <p>
                            Команда нашей компании является нашей гордостью, поэтому мы смело представляем вашему внимаю людей, благодаря которым вы приумножите свои финансы и повысите финансовую грамотность.
                        </p>
                    </div>
                </div>
                <div className='pr-5'>
                    <h2>
                        ГРИГОРИЙ ХОЛДЕН
                    </h2>
                    <h4>
                        Основатель & Арт-директор
                    </h4>
                    <p>
                        Заместитель председателя Комитета по РЕПО и кредитованию ценными бумагами Московской Биржи. Член Комитета по валютному рынку Московской биржи.
                    </p>
                    <p>
                        Окончил с отличием Московский государственный университет дизайна и технологии по специальности «Автоматизация технологических процессов и производств»
                    </p>
                </div>
                <div>
                    <img src={img_1} alt="picture_1" />
                </div>
                <div>
                    <img src={img_2} alt="picture_1" />
                </div>
                <div className='pl-5'>
                    <h2>
                        АНАТОЛИЙ ЕРЕМЕЕВ
                    </h2>
                    <h4>
                        Партнер & Операционный директор
                    </h4>
                    <p>
                        Присоединилась к компании в 2016 году. До прихода в «АТОН» работала операционным директором направления глобальных рынков в ПАО «Сбербанк». Ранее в течение 15 лет занимала различные позиции в операционном департаменте «Тройки Диалог», являлась партнером компании. Начинала свой путь сотрудником бэкофиса в ABN. Имеет опыт работы на финансовых рынках с 1999 года.
                    </p>
                    <p>
                        С отличием окончила Московский государственный лингвистический университет.
                    </p>
                </div>
                <div className='pr-5'>
                    <h2>
                        ЕВГЕНИЯ НИКИТИНА
                    </h2>
                    <h4>
                        Партнер & Менеджер операционной связи
                    </h4>
                    <p>
                        С 1999 по 2012 год работал в «Тройке Диалог», где отвечал за подбор персонала, в 2003 году была назначена руководителем управления по работе с персоналом. В 2005 году перешла на Деск акций «Тройки Диалог», где в течение семи лет успешно работала с российскими и международными институциональными клиентами, и стала партнером компании.
                    </p>
                    <p>
                        С 2012 года Евгения курирует  направления HR, PR и маркетинга.
                    </p>
                </div>
                <div>
                    <img src={img_3} alt="picture_1" />
                </div>
                <div>
                    <img src={img_4} alt="picture_1" />
                </div>
                <div className='pl-5'>
                    <h2>
                        АЛЕКСАНДР ГРЫБ
                    </h2>
                    <h4>
                        Партнер, заместитель генерального директора по юридическим вопросам
                    </h4>
                    <p>
                        С 2010 по 2015 год работал в «Альфа-Капитале» и «Альфа-Банке». С 2012 по 2015 год занимал должность руководителя юридического отдела Некоммерческого партнерства «Фондовая биржа РТС», являлся исполнительным директором Юридического комитета РТС, объединявшего ведущих юристов российского фондового рынка.
                    </p>
                    <p>
                        С 2015  года - заместитель начальника юридического управления, а затем и начальником юридического управления в компании UniCredit Aton.
                    </p>
                    <p>
                        В 2018 году его управление удостоилось премии конкурса «Элита фондового рынка» в номинации «Лучшая юридическая служба».
                    </p>
                    <p>
                        Окончил юридический факультет Московского государственного университета им. М.В. Ломоносова по специальности «Юриспруденция».
                    </p>
                </div>
            </div>
        </div>
    )
}